/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { TFunction } from 'i18next';
import { UserRow } from '../types/UserRow';
import { NullableString } from '../types/common';
import { i18nKeys } from '../utils/i18n.utils';
import { ApiClient } from './ApiClient';

export enum UserRole {
  Participant = 'participant',
  Facilitator = 'facilitator',
  Support = 'support',
}

export class UserAPI {
  constructor(private apiClient: ApiClient, private t: TFunction) {
    // do nothing
  }

  public async setUserRole(eventName: string, userId: string, nickname: string, role: UserRole, silent = false) {
    return this.apiClient.post({
      path: `/admin/events/${eventName}/users/changeRole`,
      body: {
        userId,
        role,
      },
      successMessage: this.t(i18nKeys.success.requestSucceeded.user.roleUpdated, { nickname }),
      failMessage: this.t(i18nKeys.errors.requestFailed.user.roleUpdated, { nickname }),
      silent,
    });
  }

  public async setUserToFacilitator(eventName: string, userId: string, nickname: string, silent = false) {
    return this.setUserRole(eventName, userId, nickname, UserRole.Facilitator, silent);
  }

  public async setUserToSupport(eventName: string, userId: string, nickname: string, silent = false) {
    return this.setUserRole(eventName, userId, nickname, UserRole.Support, silent);
  }

  public async setUserToParticipant(eventName: string, userId: string, nickname: string, silent = false) {
    return this.setUserRole(eventName, userId, nickname, UserRole.Participant, silent);
  }

  public async disableUserAccount(eventName: string, userId: string, nickname: string, silent = false): Promise<any> {
    return this.apiClient.post({
      path: `/admin/events/${eventName}/users/disableAccount`,
      body: { userId },
      successMessage: this.t(i18nKeys.success.requestSucceeded.user.disable, { nickname }),
      failMessage: this.t(i18nKeys.errors.requestFailed.user.disable, { nickname }),
      silent,
    });
  }

  public async enableUserAccount(eventName: string, userId: string, nickname: string, silent = false): Promise<any> {
    return this.apiClient.post({
      path: `/admin/events/${eventName}/users/enableAccount`,
      body: { userId },
      successMessage: this.t(i18nKeys.success.requestSucceeded.user.enable, { nickname }),
      failMessage: this.t(i18nKeys.errors.requestFailed.user.enable, { nickname }),
      silent,
    });
  }

  public async assignUserToTeam(
    eventName: string,
    teamName: NullableString,
    user: UserRow,
    silent = false
  ): Promise<any> {
    const { userId } = user;

    return this.apiClient.post({
      path: `/admin/events/${eventName}/users/assignTeam`,
      body: { userId, teamName },
      successMessage:
        teamName == null
          ? this.t(i18nKeys.success.requestSucceeded.user.unassign, { nickname: user.nickname })
          : this.t(i18nKeys.success.requestSucceeded.user.assign, { nickname: user.nickname, teamName }),
      failMessage: this.t(i18nKeys.errors.requestFailed.user.assign, { nickname: user.nickname }),
      silent,
    });
  }

  public changePreferrendLanguageCode(languageCode: string) {
    return this.apiClient.post({ path: `/participant/preferences/language/${languageCode}` });
  }
}
